import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../services/api.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Change Password', path: 'app/users/dashboard/change-password'}
  ];

  username: string = '';
  impersonatedEmail: any = null;
  userId: string = ''

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private route: ActivatedRoute,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Change Password")
  }

  ngOnInit(): void {
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    if (this.impersonatedEmail != null && this.username != this.impersonatedEmail) {
      //impersonate emails are not allowed on this page
      this.pageErrorMessages.push({
        field: 'Impersonated Emails not allowed on page.',
        detail: 'Consultants are not allowed to change their clients passwords.',
        severity: 'error'
      });
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    this.userId = this.auth2ServiceChild.getUserId();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }

  onSubmit(): any {
    this.pageSuccessMessages = [];
    this.pageErrorMessages = [];
    //Obtain userId
    this.userId = this.auth2ServiceChild.getUserId();
    if (!this.userId) {
      this.pageErrorMessages.push({
        field: 'UserId Error',
        detail: 'UserID: ' + this.userId + ' is not found.',
        severity: 'error'
      });
    }
    const currentPasswordEl = document.getElementById('current-password-text-id');
    // @ts-ignore
    const currentPassword = currentPasswordEl.value;
    if (!currentPassword) {
      this.pageErrorMessages.push({
        field: 'Current Password',
        detail: 'Current Password: ' + currentPassword + ' is not valid.',
        severity: 'error'
      });
    }
    //Obtain New Password
    const newPasswordEl = document.getElementById('new-password-text-id');
    // @ts-ignore
    const newPassword: string = newPasswordEl.value;
    if (!newPassword) {
      this.pageErrorMessages.push({
        field: 'New Password',
        detail: 'New Password: ' + newPassword + ' is not valid.',
        severity: 'error'
      });
    }

    //Obtain New Password
    const repeatPasswordEl = document.getElementById('repeat-password-text-id');
    // @ts-ignore
    const repeatPassword: string = repeatPasswordEl.value;
    if (!repeatPassword) {
      this.pageErrorMessages.push({
        field: 'Repeat Password',
        detail: 'Repeat Password: ' + repeatPassword + ' is not valid.',
        severity: 'error'
      });
    }

    if (newPassword !== repeatPassword) {
      this.pageErrorMessages.push({
        field: 'Password Mismatch',
        detail: 'Passwords do not match.',
        severity: 'error'
      });
    }

    if (this.pageErrorMessages.length > 0) {
      this.showPageErrorMessagesToUser();
      return;
    }
    this.userService.changePasswordV2(this.userId, this.username, currentPassword, newPassword, repeatPassword)
      .subscribe( (result: any) => {
        if (result && result.body) {
          this.auth2ServiceChild.cacheSessionFull(result.body);
          this.pageSuccessMessages.push({
            field: 'Changed Password Success',
            detail: 'Change password success.',
            severity: 'error'
          });
          this.showPageSuccessMessagesToUser();
        }
        this.routerChild.navigateByUrl('app/users/dashboard');
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Change Password Failure',
          detail: 'Failed to change password: ' + err.error.message,
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      });
  }

  onCancel(): any {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
